import { render, staticRenderFns } from "./MfaForm.vue?vue&type=template&id=521a1cb8&"
import script from "./MfaForm.vue?vue&type=script&lang=ts&"
export * from "./MfaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports